import { getIsDarkTheme } from 'owa-fabric-theme';

export default function getDefaultNoteColor() {
    return getIsDarkTheme() ? 'Charcoal' : 'Gray';
}
